//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('prodSizes', {
//        templateUrl: 'views/components/views/prodSizes/prodSizes.template.html?v=' + module.version, 
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'prodSizesService', 'rememberService', function ($stateParams, stateService, utilityService, prodSizesService, rememberService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let prodId = $stateParams.prod_id;
            
//            let variableNames = {
//                searchtext: ''
//            };

//            vm.model = {
//                searchTextButtons: [
//                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('searchtext') }
//                ],
//                setting: {},
//                itemsListProductSizes: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await prodSizesService.getProductSize({ prod_id: prodId }))[0];
//            }
            
//            async function loadProductSizes() {
//                if (utilityService.validateParmsValue(vm.model.setting.prod_id) !== true) return;

//                vm.model.itemsListProductSizes = await prodSizesService.listProductSizes({ prod_id: vm.model.setting.prod_id });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                let variableValue = null;

//                switch (id) {
//                    case 'searchtext':
//                        if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

//                        variableValue = vm.model.setting[id];
//                        break;
//                    default:
//                        break;
//                }

//                return rememberService.remember(variableNames[id], variableValue);
//            }

//		    // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            // #region RESET BUTTON FUNCTION

//            function clear(id) {
//                switch (id) {
//                    case 'searchtext':
//                        vm.model.setting.searchtext = '';

//                        rememberFunc('searchtext');
//                        break;
//                    default:
//                        break;
//                }
//            }

//		    // #endregion RESET BUTTON FUNCTION

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'searchtext':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.searchtext) !== true) return;

//                        vm.model.setting.searchtext = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.searchtext, true) !== true) return;

//                        if (vm.model.setting.searchtext === '') rememberFunc('searchtext');
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                }
//            };

//		    // #endregion FIELD CHANGE MULTI FUNCTIONS

//            vm.onBlur = function (id) {
//                switch (id) {
//                    case 'searchtext':
//                        if (utilityService.validateParmsValue(vm.model.setting.searchtext, true) !== true) return;

//                        if (vm.model.setting.searchtext > '') rememberFunc('searchtext');
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadSetting();
//                loadProductSizes();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
